/*
 * @Author: Aaron
 * @LastEditors: Aaron
 * @LastEditTime:  
 * @Desc：
 * @FilePath: 
 */

import $ from 'jquery';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import Vue from "vue";
import * as echarts from 'echarts'

import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import jpLocale from 'element-ui/lib/locale/lang/ja';
import ruLocale from 'element-ui/lib/locale/lang/en';

import AppComponent from "./Web.vue";

// 主题全局引入
import '../../../public/theme-color/#FF8004/index.css'
import './asserts/css/theme.css'; 

// 结构布局
import '../../asserts/css/public.css'; 
import '../templates/t2/asserts/css/nav.css'; 
import '../templates/t2/asserts/css/head_bottom.css'; 


Vue.prototype.$echarts = echarts;
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.component("app-component", AppComponent);


// 设置语言
Vue.use(VueI18n);
const messages = 
{
  zh: require('../classic_style/asserts/i18n/zh.json'),
  en: require('../classic_style/asserts/i18n/en.json'),
  jp: require('../classic_style/asserts/i18n/jp.json'),
  ru: require('../classic_style/asserts/i18n/ru.json'),
}
messages.zh.el = zhLocale.el;
messages.en.el = enLocale.el;
messages.jp.el = jpLocale.el;
messages.ru.el = ruLocale.el;
// Create VueI18n instance with options
const i18n =  new VueI18n({locale: localStorage.getItem('language') || 'zh',messages});

import ElementUI from 'element-ui';
Vue.use(ElementUI,{size:"small",i18n: (key, value) => i18n.t(key, value)});

new Vue({
  i18n,
  el: "#app",
  render: createElement => {
    return createElement(AppComponent);
  },
});